/** Beszólások verseny közben: karakterenként és eseményenként. */
export type QuipKind = 'start' | 'lastlap' | 'hit' | 'finish';

const QUIPS: Record<string, Record<QuipKind, string[]>> = {
  soma: {
    start: ['Anyu, nézd, vezetek!', 'Ez a gokart repül!'],
    lastlap: ['Utolsó kör? Akkor ugrok egyet!', 'Most már tényleg nyomni kell!'],
    hit: ['Jaj, ki dobott meg?!', 'Ez nem volt szép!'],
    finish: ['Megnyertem! Vagy legalábbis majdnem.', 'Soma a célban!'],
  },
  boroka: {
    start: ['Rollerrel is előzlek.', 'Sziasztok, én jövök!'],
    lastlap: ['TikTokra megy ez a kör.', 'Ez a kör már a tiéd, nézők!'],
    hit: ['Ez most nem volt menő.', 'Valaki nagyon irigy.'],
    finish: ['Szia, én voltam a gyorsabb.', 'Ez megy a storyba.'],
  },
  anya: {
    start: ['A vacsora hatra kész lesz.', 'Ki hozta a bevásárlólistát?'],
    lastlap: ['Siessünk, még bevásárolni kell!', 'Ne előzz, fiam!'],
    hit: ['Ezt a fiúknak megmondom.', 'Valaki ma nem kap vacsorát.'],
    finish: ['Megvan, mehetünk haza.', 'A családi logisztika győzött.'],
  },
  apa: {
    start: ['Ez a kocsi még húsz évig bírja.', 'Olajcsere után meglátod!'],
    lastlap: ['Hétvégén szétszedem és megnézem.', 'Most jön a szerelői tudás!'],
    hit: ['Ki volt az? Mindjárt megnézem.', 'Ez a biztosítékot is veri.'],
    finish: ['Hétvégén szétszedem és megnézem.', 'Megvan, és még mindig bírja.'],
  },
  robi: {
    start: ['Kihűl a leves!', 'Ez a rendelés még ma odaér!'],
    lastlap: ['Bocs, előzök, éhes a vendég.', 'A borravaló a tét!'],
    hit: ['Ki borította fel a levest?!', 'Ez a rendelés késik.'],
    finish: ['Kihűlt a leves, de megérkeztem.', 'Öt csillag, ugye?'],
  },
  gabor: {
    start: ['Törékeny csomag!', 'Aláírás itt, kérem!'],
    lastlap: ['Ez a csomag sosem ér oda.', 'A címzett már vár!'],
    hit: ['Ezért alá kell írni!', 'A csomag sérült, a sofőr is.'],
    finish: ['Átadtam, kérem az aláírást.', 'Csomag kézbesítve, gyorsan.'],
  },
  tibi: {
    start: ['Index? Minek?', 'A külső sáv az enyém.'],
    lastlap: ['Ez egy BMW, nem kell magyarázni.', 'Félre az útból!'],
    hit: ['Ez a verseny, nem óvoda!', 'Ki mer utolérni?'],
    finish: ['Megérkeztem, nem előztem.', 'A BMW mindig nyer.'],
  },
  bela: {
    start: ['Nyugdíjas tempó, fiatalok!', 'Régen minden jobb volt.'],
    lastlap: ['Nem sietek sehova.', 'Vasárnap is csak a templomig megyek.'],
    hit: ['Ejnye, ejnye!', 'Ez nem a házasságom volt, de fájt.'],
    finish: ['Hazaérek ebédre.', 'Régen minden jobb volt, de ez is jó.'],
  },
  krisztina: {
    start: ['A meeting kilenckor kezdődik!', 'Még a hajam is siet.'],
    lastlap: ['Tárgyalunk a kanyarban.', 'A napirend: előzés.'],
    hit: ['Ezt beírom a jegyzőkönyvbe.', 'Ez nem volt a napirenden.'],
    finish: ['Megbeszélés lezárva.', 'A negyedóra megvan, mehetünk.'],
  },
};

const FALLBACK: Record<QuipKind, string[]> = {
  start: ['Rajt!', 'Gyerünk!'],
  lastlap: ['Utolsó kör!', 'Hajrá!'],
  hit: ['Azt a mindenit!', 'Ez fájt!'],
  finish: ['Cél!', 'Megvagyok!'],
};

export function quipFor(id: string, kind: QuipKind): string {
  const set = QUIPS[id] ?? FALLBACK;
  const pool = set[kind] ?? FALLBACK[kind];
  return pool[Math.floor(Math.random() * pool.length)] ?? 'Hajrá!';
}
